// src/components/Layout.js
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Main from './Main';
import BarMain from './BarMain';

const Layout = ({ children }) => {
  return (
    <div>
        <BarMain />
        <Header />
        <Main>{children}</Main>
        <Footer />
    </div>
  );
};

export default Layout;
